module.exports = __webpack_public_path__ + "img/zh_hk.e9896c55.png";